import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Const, Tooltip} from "@app/_helper";
import {Account, RoleType} from "@app/_model";
import {AuthService} from "@app/_service";
import {MatIconModule} from "@angular/material/icon";
import {RouterModule} from "@angular/router";
import {ClientPicker} from "@app/module/auth/client/client.picker";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatButtonModule} from "@angular/material/button";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';

@Component({
  selector: 'app-menu',
  standalone: true,
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterModule,
    MatIconModule,
    MatToolbarModule,
    MatButtonModule,
    MatTooltipModule,
    MatMenu,
    MatMenuTrigger,
    MatMenuItem,
    ClientPicker
  ]
})
export class MenuComponent implements OnInit {
  account?: Account | null;

  protected readonly Const = Const;
  protected readonly RoleType = RoleType;

  protected readonly Tooltip = Tooltip.getInstance();

  constructor(
    private readonly authService: AuthService
  ) {
  }

  public ngOnInit(): void {
    this.authService.account.subscribe(account => this.account = account);
  }

  protected authIsNeed2fa(): boolean {
    return this.authService.isNeed2fa;
  }

  protected accountHasRole(role: RoleType): boolean {
    return this.authService.accountHasRole(role);
  }
}
